import * as React from "react";

type Repo = { name: string; description: string; href: string };

const repos: Repo[] = [
  {
    name: "aash",
    description:
      "Dashboard for crypto-backed debt — tools and primitives for managing and monitoring positions on Aave and Morpho.",
    href: "https://github.com/huskly/aash",
  },
  {
    name: "incomash",
    description:
      "A simple tool to track dividend income and distributions for any portfolio.",
    href: "https://github.com/huskly/incomash",
  },
  {
    name: "schwab-client",
    description:
      "Ruby client for the Charles Schwab trading and market data API, with OAuth flow and typed responses.",
    href: "https://github.com/huskly/schwab-client",
  },
  {
    name: "tos-wsjson-client",
    description:
      "Client for the ThinkOrSwim WebSocket JSON API — streaming quotes, options chains, and account data.",
    href: "https://github.com/huskly/tos-wsjson-client",
  },
];

const OpenSource = () => (
  <section id="open-source" className="border-t border-stone-200">
    <div className="max-w-6xl mx-auto px-6 sm:px-10 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-3">
        <p className="text-xs uppercase tracking-[0.2em] text-stone-500">
          Open source
        </p>
        <h2 className="mt-4 font-serif text-3xl sm:text-4xl text-stone-900 leading-tight">
          Tools we share.
        </h2>
        <p className="mt-5 text-stone-600 leading-relaxed font-light">
          Pieces of our internal stack and tooling that we've open sourced.
        </p>
      </div>
      <div className="lg:col-span-9">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {repos.map((r) => (
            <a
              key={r.name}
              href={r.href}
              target="_blank"
              rel="noreferrer"
              className="group rounded-xl border border-stone-200 bg-white p-8 hover:border-stone-400 transition-colors"
            >
              <div className="flex items-center justify-between">
                <h3 className="font-mono text-lg text-stone-900">{r.name}</h3>
                <span
                  aria-hidden
                  className="text-stone-400 group-hover:text-stone-900 transition-colors"
                >
                  ↗
                </span>
              </div>
              <p className="mt-4 text-stone-700 leading-relaxed font-light">
                {r.description}
              </p>
            </a>
          ))}
        </div>
        <a
          href="https://github.com/orgs/huskly/repositories"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 mt-8 text-stone-700 hover:text-stone-900 transition-colors"
        >
          More on GitHub <span aria-hidden>→</span>
        </a>
      </div>
    </div>
  </section>
);

export default OpenSource;
